import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { axiosInstance } from "utils/axiosInstance";

export const useUploadHelper = ({ payload, setPayload }: any) => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useMutation({
    mutationFn: async (imageData: string | Blob) => {
      if (!imageData) throw new Error("No file selected");

      const formData = new FormData();

      if (typeof imageData === "string") {
        const blob = await (await fetch(imageData)).blob();
        formData.append("file", blob, "image.png");
      } else {
        formData.append("file", imageData);
      }

      const response = await axiosInstance.post("misc/file-uploads", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    },
    onSuccess: (data) => {
      console.log("✅ File uploaded successfully", data);
      let result = data?.data?.fileUrl;
      setPayload({ ...payload, images: [...payload?.images, result] });
    },
    onError: (error: any) => {
      console.error("❌ Upload failed", error);
      message.error(
        error?.response?.data?.message ||
          "Error uploading file, please try again."
      );
    },
  });
};
